import { useTranslate } from '_core/hooks/useTranslate';
import TextHtml from '_core/modules/atoms/TextHtml';
import PdfViewerFullScreen from '_core/modules/components/pdfViewers/PdfViewerFullScreen/PdfViewerFullScreen';
import * as coreEntities from '_core/store/index';
import { PRIVACY } from 'app/config/config';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const PrivacyPolicy = () => {
  const { t } = useTranslate();
  const language = useSelector((state) => coreEntities.i18n.selectors.getLanguage(state));
  const [showPdfViewer, setShowPdfViewer] = useState(false);

  let lang = language && Object.keys(PRIVACY).includes(language) ? language : 'es';

  useEffect(() => {
    let elements = document.getElementsByClassName('pprivacy');
    if (elements.length > 0) {
      document.getElementsByClassName('tyc_legal')[0].innerHTML = elements[0].innerHTML;
    }
    if (PRIVACY[lang] && PRIVACY[lang].endsWith('pdf')) {
      setShowPdfViewer(true);
    } else {
      setShowPdfViewer(false);
    }
  }, []);

  return showPdfViewer ? (
    <div>
      <PdfViewerFullScreen url={PRIVACY[lang]} />
    </div>
  ) : (
    <div className="dialog-terms">
      <div>{t('login:Privacidad')}</div>
      <TextHtml text={PRIVACY[lang]} />
    </div>
  );
};

export default PrivacyPolicy;
